export default __webpack_public_path__ + "static/media/likes.24faf1fc.wav";